module.exports = __webpack_public_path__ + "img/规则.c46f67ae.png";